import { render, staticRenderFns } from "./AdminDefault.vue?vue&type=template&id=75371978"
import script from "./AdminDefault.vue?vue&type=script&lang=js"
export * from "./AdminDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports